import { render, staticRenderFns } from "./CustomerFRSO.vue?vue&type=template&id=591ea552&scoped=true&"
import script from "./CustomerFRSO.vue?vue&type=script&lang=ts&"
export * from "./CustomerFRSO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591ea552",
  null
  
)

export default component.exports